import { Component, Input } from "@angular/core";
import { PropostaService } from "administrativo-lib";
import { BaseResourceRptComponent, Coluna, CpfPipe, GlobalService, Licitacao, LicitacaoPipe, Proposta, SituacaoProposta } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-classificacao-rpt',
  templateUrl: './classificacao-rpt.component.html'
})
export class ClassificacaoRptComponent extends BaseResourceRptComponent {

  @Input() public licitacao: Licitacao;

  public agrupamento: 'MEMORIAL' | 'PROPONENTE';
  public listAgrupamento: { id: 'MEMORIAL' | 'PROPONENTE', nome: string }[];
  private situacoesProposta: { id: SituacaoProposta, nome: string, style: string, ordem: number }[];

  constructor(
    private globalService: GlobalService,
    private propostaService: PropostaService
  ) {
    super();
  }

  protected afterInit(): void {
    this.listAgrupamento = [
      { id: 'MEMORIAL', nome: 'Agrupar por Itens do Memorial' },
      { id: 'PROPONENTE', nome: 'Agrupar por Favorecidos' },
    ];
    this.agrupamento = 'MEMORIAL';

    this.situacoesProposta = this.globalService.obterSituacoesProposta();
  }

  protected tituloRelatorio(): string {
    return `Classificação Final de Propostas - ${new LicitacaoPipe().transform(this.licitacao.numero)}`;
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = [];
    if (this.agrupamento === 'MEMORIAL') {
      retorno.push({ titulo: 'Item:', coluna: 'item', bold: true, agrupar: true });
      retorno.push({ titulo: 'Favorecido', coluna: 'favorecido' });
    } else {
      retorno.push({ titulo: 'Favorecido:', coluna: 'favorecido', bold: true, agrupar: true });
      retorno.push({ titulo: 'Item', coluna: 'item' });
    }
    retorno.push({ titulo: 'Marca', coluna: 'marca' });
    retorno.push({ titulo: 'Qtde.', coluna: 'qtde', decimais: 0, alignment: 'right' });
    retorno.push({ titulo: 'Valor Unit.', coluna: 'valor', decimais: 4, alignment: 'right' });
    retorno.push({ titulo: 'Valor Total', coluna: 'total', decimais: 4, alignment: 'right' });
    retorno.push({ titulo: 'Situação', coluna: 'situacao', bold: true, alignment: 'center' });

    return retorno;
  }

  protected larguraColunas(): (string | number)[] {
    return ['*', 100, 'auto', 'auto', 'auto', 'auto'];
  }

  protected totalizarColunas(): (string | {})[] {
    return undefined;
  }

  protected carregarLista(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const lista: {
        item: string,
        favorecido: string,
        marca: string,
        qtde: number,
        valor: number,
        total: number,
        situacao: string,
      }[] = [];
      this.propostaService.obterPorLicitacao(this.licitacao.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const reg: Proposta[] = res.content;

          // ordena lista de acordo com agrupamento e situação, respectivamente
          if (this.agrupamento === 'MEMORIAL') {
            reg
              .sort((a, b) => { return a.proponente.favorecido.nome.localeCompare(b.proponente.favorecido.nome) })
              .sort((a, b) => { return this.situacoesProposta.find(s => s.id === a.situacao).ordem - this.situacoesProposta.find(s => s.id === b.situacao).ordem })
              .sort((a, b) => { return a.memorial.ordem - b.memorial.ordem })
          } else {
            reg
              .sort((a, b) => { return a.memorial.ordem - b.memorial.ordem })
              .sort((a, b) => { return this.situacoesProposta.find(s => s.id === a.situacao).ordem - this.situacoesProposta.find(s => s.id === b.situacao).ordem })
              .sort((a, b) => { return a.proponente.favorecido.nome.localeCompare(b.proponente.favorecido.nome) })
          }

          reg.forEach(p => {
            lista.push({
              item: `${p.memorial.descricao} ${p.memorial.unidade}`,
              favorecido: `${new CpfPipe().transform(p.proponente.favorecido.cpf_cnpj)} - ${p.proponente.favorecido.nome}`,
              marca: p.marca,
              qtde: p.situacao === 'VENCEDOR' ? p.quantidade_final : p.memorial.quantidade,
              valor: p.situacao === 'VENCEDOR' ? p.valor_final : p.valor_unitario,
              total: p.situacao === 'VENCEDOR' ? p.quantidade_final * p.valor_final : p.memorial.quantidade * p.valor_unitario,
              situacao: this.situacoesProposta.find(p2 => p2.id === p.situacao).nome,
            })
          });

          resolve(lista);
        });
    })
  }
}